<template>
  <main>
    <section class="box">
      <p class="title">关于我们</p>
      <h2>深圳市常顺旅行社有限公司简介</h2>
      <article>
        <p>
          深圳市常顺旅行社有限公司（简称“常顺”）创立于2004年，是经国家旅游局批准的出境旅游组团社，3A级旅行社、深圳市旅行社协会常务理事单位、罗湖区旅游协会副会长单位、深圳市企业联合会副会长单位、深圳市湖北商会副会长单位，曾获2017年印度国家旅游局颁发旅游产品销售第五名、2018年新加坡国家旅游局颁发会奖旅游销售最具潜力奖及深圳旅游业多项奖项，并在2023年度成为深圳市的“四上”企业。
        </p>
        <p>
          经过21年的精心耕耘，常顺已经发展成一家集互联网科技、旅游度假和商旅管理于一体的多元化企业。总部设在深圳，北京、广州及武汉设有分公司，公司从专业为中国公民代办各国签证业务逐步发展到酒店预订、机票预订、商旅会议、旅游、会议策划、会奖活动及旅游资讯等旅行服务。公司自成立以来每年服务50多万人次前往世界各国签证、机票、酒店、旅游、会奖等业务。在旅游同业中，常顺是华南地区最大、最专业的旅游产品供应商。
        </p>
        <p>
          为更好地服务客户，公司培养了一支业务水平高，专业知识广，服务意识强，工作经验丰富的精英团队，赢得了无数客户的青睐和支持，在业内享有了极高的知名度，拥有了一大批多年紧密合作的客户及代理商，竞争力不断提升。
        </p>
        <p>
          应市场需要，公司于2016年自主开发常顺旅游在线平台，平台运用签证知识库、自然语言处理、大模型等人工智能技术，结合区块链技术，搭建了分布式S2B2C平台，集供应链、分销销售、智能操作、智能工具、可视化订单跟踪、员工培训、财务审核和管理于一体，构建了覆盖文旅全产业链的技术解决方案，免费助力中小旅游企业数字化升级。平台运行至今已服务同业分销商7000多家及30000多终端客户，自新冠疫情后更是发展成为为中小型旅游企业和旅游从业人员赋能的销管平台系统。2024年平台荣获“广东省智慧旅游培育项目”称号，2025年平台荣获“人工智能+文旅应用场景典型案例”称号。
        </p>

        <video controls width="100%" class="videos" poster="@assets/img/videoPoster.png">
          <source src="@assets/img/aboutUs.mp4" type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>

        <p>
          作为旅游服务行业中的一员，常顺旅行社以“满足客户需求为己任，以诚信经营为准则，以高效卓越为追求”作为经营理念，以“尊重对手，尊重市场，合作双赢，共同发展”作为公司与同业合作的基本原则。“让天下人随心所欲走世界”是常顺人的使命，“让旅游人没有难做的生意”是常顺人的愿景，常顺坚持“诚信、高效、团结、务实”的核心价值观，努力将客户体验放在第一位，不断提高产品质量和服务水平，让客户尽量少花钱，少花精力就能享受到我们公司的优质服务，体验到办理旅行手续过程的便利与轻松。
        </p>
        <p class="rightAlign">
          深圳市常顺旅行社有限公司
        </p>
        <p class="rightAlign">
          2025年9月15日
        </p>
      </article>
      <p class="contents">





      </p>
    </section>
  </main>
</template>

<script>
export default {
  created() {
    this.scrollTo();
  }
}
</script>

<style>
main {
  background: #fff;

  .box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 30px;
    line-height: 2;

    .title {
      display: flex;
      align-items: center;
      height: 40px;
      margin: 30px 0 0;
      font-size: var(--fs_l);
      font-weight: bold;
      color: var(--main);
      border-bottom: 1px solid var(--bdr_light);
    }

    h2 {
      text-align: center;
      font-size: var(--fs_xl);
      font-weight: bold;
      color: var(--txt_bold);
      margin: 20px 0 20px;
    }

    article {
      p {
        text-indent: 28px;
        line-height: 2em;
      }

      .rightAlign {
        text-align: right;
      }

      .videos {
        max-width: 90%;
        display: block;
        margin: 20px auto;
        position: relative;
        filter: drop-shadow(0 0 24px rgba(0, 0, 0, .45));
        border: none;
        /* 保险：显式去掉边框 */
        outline: none;
        border-radius: 4px;
      }
    }

  }
}

@media only screen and (max-width: 768px) {
  main {
  }
}
</style>